// =====================================================
// POLICIES API
// CRUD para pólizas de aseguradoras
// =====================================================

import { api } from './client';

export interface Policy {
  id: string;
  companyId: string;
  insuranceCompanyId: string;
  insuranceCompanyCode?: string;
  insuranceCompanyName?: string;
  code: string;
  name: string;
  description: string | null;
  isDefault: boolean;
  isActive: boolean;
  tariffsCount?: number;
  createdAt: string;
  updatedAt: string;
}

export interface PolicySelect {
  id: string;
  code: string;
  name: string;
  insuranceCompanyId: string;
  insuranceCompanyName?: string;
  isDefault: boolean;
}

export interface CreatePolicyRequest {
  insuranceCompanyId: string;
  code: string;
  name: string;
  description?: string;
  isDefault?: boolean;
}

export interface UpdatePolicyRequest {
  insuranceCompanyId?: string;
  code?: string;
  name?: string;
  description?: string;
  isDefault?: boolean;
  isActive?: boolean;
}

const BASE_URL = '/policies';

export const policiesApi = {
  /**
   * Obtener lista para select (solo activas)
   */
  getForSelect: (insuranceCompanyId?: string): Promise<PolicySelect[]> => {
    const query = insuranceCompanyId ? `?insuranceCompanyId=${insuranceCompanyId}` : '';
    return api.get<PolicySelect[]>(`${BASE_URL}/select${query}`);
  },

  /**
   * Obtener todas las pólizas
   */
  getAll: (includeInactive = false, insuranceCompanyId?: string): Promise<Policy[]> => {
    const params = new URLSearchParams();
    if (includeInactive) params.set('includeInactive', 'true');
    if (insuranceCompanyId) params.set('insuranceCompanyId', insuranceCompanyId);
    const query = params.toString();
    return api.get<Policy[]>(`${BASE_URL}${query ? `?${query}` : ''}`);
  },

  /**
   * Obtener una póliza por ID
   */
  getById: (id: string): Promise<Policy> => {
    return api.get<Policy>(`${BASE_URL}/${id}`);
  },

  /**
   * Crear nueva póliza (solo admin)
   */
  create: (data: CreatePolicyRequest): Promise<Policy> => {
    return api.post<Policy>(BASE_URL, data);
  },

  /**
   * Actualizar póliza (solo admin)
   */
  update: (id: string, data: UpdatePolicyRequest): Promise<Policy> => {
    return api.patch<Policy>(`${BASE_URL}/${id}`, data);
  },

  /**
   * Desactivar póliza (solo admin)
   */
  deactivate: (id: string): Promise<Policy> => {
    return api.delete<Policy>(`${BASE_URL}/${id}`);
  },

  /**
   * Reactivar póliza (solo admin)
   */
  reactivate: (id: string): Promise<Policy> => {
    return api.patch<Policy>(`${BASE_URL}/${id}/reactivate`);
  },
};

export default policiesApi;
